import React, {useState} from 'react';
import style from '../PaperworkList/PaperworkList.module.css';
import s from './CastomerOrders.module.css';
import menuArrow from '../../assets/img/icons/downward-arrow 1.svg';
import TableFullViewProductEl from '../../Components/TableCommonDirectory/TableElements/TableFullViewProductEl';
import {OrderInDepotLogisticType} from '../../types/TypesDepotLogistic';
import {useTranslation} from 'react-i18next';
import CustomerOrderAction from './components/CustomerOrderAction';
import {
	deliveryStatusTranslate,
	invoiceStatusTranslate,
	paymentMethodTranslate,
} from '../../assets/utils/translatersFunc';
type Props = {
	order: OrderInDepotLogisticType;
	index: number;
	onDeleteSuccess: (id: number) => void;
};
const CustomerOrdersRowElement: React.FC<Props> = ({
	order,
	index,
	onDeleteSuccess,
}) => {
	const {t} = useTranslation();
	const [open, setOpen] = useState(false);
	const orderColorSelector = (
		statusPay: boolean,
		deliveryType: string,
		status: string,
		paymentMethod: string,
	): string => {
		switch (true) {
			case statusPay && deliveryType === 'post' && status === 'confirmed':
				return 'colorGreen';
			case deliveryType === 'self-delivery' &&
				status === 'confirmed' &&
				!statusPay &&
				paymentMethod === 'afterpay':
				return 'colorYellow';
			case status === 'created' || (!statusPay && paymentMethod === 'card'):
				return 'colorGrey';
			default:
				return 'colorGrey';
		}
	};
	const orderColor =
		orderColorSelector(
			order.status_pay,
			order.delivery_type,
			order.status,
			order.payment_method,
		) ?? '';
	return (
		<>
			<div className={`${style.tableRow} ${s.tableRow}`}>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					<img
						role={'button'}
						tabIndex={0}
						onClick={() => setOpen(!open)}
						style={{transform: !open ? 'rotate(180deg)' : ''}}
						src={menuArrow}
						alt="arrow"
					/>
				</div>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					<div className={`${s.colorCircle} ${s[orderColor]}`}>{index + 1}</div>
				</div>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					{order.order_id}
				</div>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					{order.order_date?.slice(0, 10)}
				</div>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					{order.username}
				</div>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					{order.pay_money} {order.currency ?? 'грн'}
				</div>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					{invoiceStatusTranslate(order.status)}
				</div>
				<div className={`${style.tableColumn} ${s.tableColumn}`}>
					<CustomerOrderAction
						orderId={order.order_id}
						orderStatusPay={order.status_pay}
						orderStatus={order.status}
						onDeleteSuccess={onDeleteSuccess}
					/>
				</div>
			</div>
			{open && (
				<>
					<div className={s.methodsBlock}>
						<div className={s.methodsBlockColumn}>
							<div className={s.methodsBlockColumnTitle}>
								{t('Спосіб доставки')}
							</div>
							<div className={s.methodsBlockColumnInfo}>
								{deliveryStatusTranslate(order.delivery_type)}
							</div>
						</div>
						<div className={s.methodsBlockColumn}>
							<div className={s.methodsBlockColumnTitle}>
								{t('Спосіб оплати')}
							</div>
							<div className={s.methodsBlockColumnInfo}>
								{paymentMethodTranslate(order.payment_method)}
							</div>
						</div>
						<div className={s.methodsBlockColumn}>
							<div className={s.methodsBlockColumnTitle}>
								{t('Статус оплати')}
							</div>
							<div className={s.methodsBlockColumnInfo}>{order.status_pay}</div>
						</div>
					</div>
					<div className={s.colorRow} />
					<TableFullViewProductEl order={order} active={open} />
				</>
			)}
		</>
	);
};

export default CustomerOrdersRowElement;
